module.exports = __webpack_public_path__ + "mainassets/img/cloud-upload.cee34f9f.svg";